import { symbolPreviewRegistry } from '@/features/_shared/symbol-preview-registry';

import FactsheetDialogButton from '../components/FactsheetDialogButton';
import FactsheetDialogButtonBase from '../components/FactsheetDialogButton/FactsheetDialogButtonBase';

symbolPreviewRegistry.registerInfo(
  code => <FactsheetDialogButton code={code} />,
  (code, children) => <FactsheetDialogButtonBase code={code}>{children}</FactsheetDialogButtonBase>
);
